import React, { useEffect, useState } from 'react'
import { AcessoRapido, AuditoriaAgenda, ProximosAgendamentos, GraficosFaturamento } from '../../components/ContentCards'
import { getUsuario } from '../../util/Configuracoes'
import { get } from '../../util/AcessoApi'

import { Link } from 'react-router-dom'

const Dashboard = (props) => {
    const user = getUsuario()
    const [permissoes, setPermissoes] = useState([])
    const [urlProducaoFaturamento, setUrlProducaoFaturamento] = useState()


    useEffect(() => {
        Promise.resolve(get('/controleAcesso/permissao/obterTodas', { usuario_id: user.id })).then(
            (val) => {
                setPermissoes(val)
            })
    }, [])


    return (<>
        <div className='row'>
            <AcessoRapido permissoes={permissoes} />
        </div>
    </>)
}

export default Dashboard
